export default __webpack_public_path__ + "static/img4-c5708583afe58b0f6367f4f44bb7cf8e.jpg";